import { render, staticRenderFns } from "./SalesCrmContacts.vue?vue&type=template&id=5d5976a3&scoped=true&"
import script from "./SalesCrmContacts.vue?vue&type=script&lang=js&"
export * from "./SalesCrmContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5976a3",
  null
  
)

export default component.exports